<template>
  <ul :class="{ 'active': active }" class="absolute top-0 w-full left-0 transition-all duration-300 ease-in-out">
    <li v-if="parent" class="flex w-full relative">
        <span class="absolute left-0 top-0 bottom-0 flex items-center px-3 p-2 cursor-pointer" @click.stop.prevent="back(parent.id || 0)">
          <svg aria-label="back" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </span>
        <a

          :title="parent.title"
          :target="parent.target"
          :rel="parent.rel"
          :href="parent.url"
          class="block w-full text-center font-bold px-4 py-3"
          v-on="parent.url === '#' ? { click: ($event) => {
            $event.preventDefault()
            $event.stopPropagation()
            back(parent.id || 0)
          }} : {}"
          :class="parent.class"
        >
          {{ parent.label }}
        </a>
    </li>
    <li v-else class="flex w-full relative">
        <span class="absolute left-0 top-0 bottom-0 flex items-center px-3 p-2 cursor-pointer" @click.stop.prevent="close()">
          <svg aria-label="back" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
      </span>
        <a
          @click.stop.prevent="close()"
          class="block w-full text-center px-4 py-3 font-bold "
        >
          Bodyfit Mums
        </a>
    </li>
    <li
      v-for="node in nodes"
      :key="node.id"
    >
      <div>
        <div class="flex w-full relative ">
          <a
            :title="node.title"
            :target="node.target"
            :rel="node.rel"
            :href="node.url"
            class="w-full px-8 py-3 block hover:bg-primary-800 text-lg font-bold"
            :class="node.class"
            v-on="node.url === '#' ? { click: ($event) => {
              $event.preventDefault()
              $event.stopPropagation()
              next(node.id)
            }} : {}"
          >
            {{ node.label }}
          </a>
          <span
            v-if="node.nodes && node.nodes.length > 0"
            class="absolute right-0 top-0 bottom-0 flex items-center px-8 p-2 cursor-pointer"
            @click.stop.prevent="next(node.id)"
          >
            <svg aria-label="children" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </span>
        </div>
        <p v-if="node.description" class="px-4 text-sm pb-4">{{ node.description }}</p>
      </div>
      <slinky-list
        v-if="node.nodes && node.nodes.length > 0"
        :nodes="node.nodes"
        :active="checkActive(node.id)"
        :parent="node"
        @back="$emit('back', $event)"
        @next="$emit('next', $event)"
      ></slinky-list>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'SlinkyList',
  props: {
    value: {
      default: 0,
      type: Number
    },
    parent: {
      type: Object,
      required: false,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    },
    nodes: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      isActive: 0
    }
  },
  methods: {
    back(id) {
      this.isActive = 0
      this.$parent.isActive = 0
      this.$emit('back', id)
    },
    next(id) {
      this.isActive = id
      this.$emit('next', id)
    },
    close() {
      this.$emit('close')
    },
    checkActive(id) {
      if (this.isActive === id) {
        return true
      }
      return false
    }
  }
}
</script>
